export default "__VITE_ASSET__BDtDGPKT__"